<template>
    <div class="parttypes">
      <div style="margin-bottom: 20px">
        <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
        <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
      </div>
      <div style="border: 1px solid #c9cdd6">
        <el-table
            :header-cell-style="{background:'#F5F5F5'}"
            :data="tableData"
            max-height="600"
            style="width: 100%"
        >
          <el-table-column
              prop="partname"
              label="零件类型">
          </el-table-column>
          <el-table-column
              prop="partcode"
              label="零件编码">
          </el-table-column>
          <el-table-column
              prop="address"
              fixed="right"
              width="150"
              align="center"
              label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
              <!--            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
  <!--    &lt;!&ndash; 分页 &ndash;&gt;-->
  <!--    <div style="margin-top: 20px">-->
  <!--      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'-->
  <!--                  @handleCurrentChange='handleCurrentChange'></Pagination>-->
  <!--    </div>-->
      <el-dialog
          :title="modelTitle"
          :close-on-click-modal="false"
          :visible.sync="dialogVisible"
          width="30%">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"  class="demo-ruleForm">
          <el-form-item label="零件名称" prop="partname">
            <el-input v-model="ruleForm.partname" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="零件编码" prop="partcode">
            <el-input v-model="ruleForm.partcode" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="上级" >
          <el-cascader  :options="parts" ref="cascaderRef" v-model="ruleForm.parentid"  :props="{ checkStrictly: true }" @change="cascaderChange" style="width: 100%">
          </el-cascader>
        </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
            <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
import { Select } from 'element-ui';  
  export default {
    data() {
      let _that=this
      return {
        isShowInfo:false,
        tableData: [],
        parts:[],
        modelTitle: '新增零件类型',
        dialogVisible: false,
        ruleForm: {
          partname: '',
          partcode: '',
          parentid:0
        },
        rules: {
          partname: [
            {required: true, message: '请输入零件类型', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      cascaderChange(e){
          this.ruleForm.parentid=e[e.length-1]
      },
      search() {
        this.init()
      },
      addItem() {
        this.modelTitle = '新增零件类型'
        this.ruleForm = {}
        this.getParts(-1);
        this.dialogVisible = true
      },
      editorClick(row) {
        this.modelTitle = '编辑零件类型'
        this.ruleForm = {
          id:row.id,
          partname: row.partname,
          partcode: row.partcode,
          parentid:row.parentid
        }
        this.getParts(row.id);
        this.dialogVisible = true
      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let data = {
              ...this.ruleForm,
            }
            if (this.modelTitle === '编辑零件类型') {
              this.axios
                  .put("api/PartType", data).then((res) => {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                },);
                this.$refs[formName].resetFields();
                this.dialogVisible=false;
                this.init();
              })
            } else {
              this.axios
                    .post("api/PartType", data).then((res) => {
                this.$message({
                  message: '操作成功',
                  type: 'success'
                });
                this.$refs[formName].resetFields();
                this.dialogVisible=false;
                this.init();
                
              })
            }
          } else {
            return false;
          }
        });
      },
      init() {
        this.axios
            .get("api/PartType/all")
            .then((res) => {
              this.tableData = res;
            })
      },
      getParts (id) {
      const tree = []
      this.tableData.forEach(item => {
        if (item.parentid == 0) {
          var disable=false;
          if(id==item.parentid||item.id==id)
          {
            disable=true;
          }
          var list=this.getchildren(id,disable,item.id);
          if(list.length>0)
          {
            tree.push({value:item.id,label:item.partname,disabled:disable,children:list })
          }
          else
          {
            tree.push({value:item.id,label:item.partname,disabled:disable})
          }
        
        }
      })
      this.parts=tree
      },
      getchildren(id,disable,parentid){
      const children = []
      this.tableData.forEach(item => {
        if (item.parentid == parentid) {
          if((!disable&&id==item.parentid)||item.id==id)
          {
            disable=true;
          }
          var list=this.getchildren(id,disable,item.id);

          if(list.length>0)
          {
            children.push({value:item.id,label:item.partname,disabled:disable,children:list })
          }
          else
          {
            children.push({value:item.id,label:item.partname,disabled:disable})
          }
         
        }
      })
      return children
      },
    },
    mounted() {
    this.init()
  }


  }
  </script>
  
  <style lang="scss" scoped>
   .parttypes {
  }
  </style>